// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UtWlrsFCvcMarXBTsOJ5{flex-direction:column;padding:8px 24px 32px;display:flex}.Vv5lbXIvmUAoTFYHK15v{background:var(--background-neutral-subtle);align-items:flex-start;gap:12px;margin-top:24px;padding:12px;display:flex}.h0SXOShBfTwqVADbYstc{white-space:pre-wrap;overflow-wrap:anywhere}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"copyWrapper": `UtWlrsFCvcMarXBTsOJ5`,
	"copyBlock": `Vv5lbXIvmUAoTFYHK15v`,
	"script": `h0SXOShBfTwqVADbYstc`
};
export default ___CSS_LOADER_EXPORT___;
